import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

const areaImages = {
  a: [
    "https://images.unsplash.com/photo-1660015154403-0fd84e5d810d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmb29kJTIwZGlzdHJpYnV0aW9uJTIwcG9vcnxlbnwwfHx8fDE3ODU2OTQ1ODV8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1536514888772-a269c6a8a198?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxpbmRpYSUyMHNlcnZpbmclMjBmb29kJTIwcG9vcnxlbnwwfHx8fDE3ODU2OTQ1OTZ8MA&ixlib=rb-4.1.0&q=85",
  ],
  b: [
    "https://images.unsplash.com/photo-1562709911-a355229de124?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBlbGRlcmx5JTIwY2FyZXxlbnwwfHx8fDE3ODU2OTQ1OTZ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1697305593259-d96aa6ed0e14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBlbGRlcmx5JTIwY2FyZXxlbnwwfHx8fDE3ODU2OTQ1OTZ8MA&ixlib=rb-4.1.0&q=85",
  ],
  c: [
    "https://images.pexels.com/photos/3231359/pexels-photo-3231359.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/15119089/pexels-photo-15119089.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
  d: [
    "https://images.pexels.com/photos/34212681/pexels-photo-34212681.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1779006277040-67543ea167b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxpbmRpYSUyMGRvY3RvciUyMHBhdGllbnR8ZW58MHx8fHwxNzg1Njk0NTk2fDA&ixlib=rb-4.1.0&q=85",
  ],
  e: [
    "https://images.unsplash.com/photo-1587538018365-2a1f8b544c08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxpbmRpYSUyMHJ1cmFsJTIwd29tZW4lMjBzZWxmJTIwaGVscCUyMGdyb3VwfGVufDB8fHx8MTc4NTY5NDU5Nnww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1609252509229-364936a1d1a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxpbmRpYSUyMHJ1cmFsJTIwd29tZW4lMjBzZWxmJTIwaGVscCUyMGdyb3VwfGVufDB8fHx8MTc4NTY5NDU5Nnww&ixlib=rb-4.1.0&q=85",
  ],
  f: [
    "https://images.unsplash.com/photo-1698884291950-dc5be5fceb4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB3aGVlbGNoYWlyfGVufDB8fHx8MTc4NTY5NDU4NXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1732194439368-4655fd0ea955?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3aGVlbGNoYWlyfGVufDB8fHx8MTc4NTY5NDU4NXww&ixlib=rb-4.1.0&q=85",
  ],
  g: [
    "https://images.unsplash.com/photo-1586618770443-e6f8167fca61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB2aWxsYWdlJTIwcGVvcGxlfGVufDB8fHx8MTc4NTY5NDU4NHww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1632414237690-7713a79fe9d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB2aWxsYWdlJTIwcGVvcGxlfGVufDB8fHx8MTc4NTY5NDU4NHww&ixlib=rb-4.1.0&q=85",
  ],
  h: [
    "https://images.unsplash.com/photo-1551855350-c86caeaf8707?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHx0cmVlJTIwcGxhbnRhdGlvbiUyMHZvbHVudGVlcnxlbnwwfHx8fDE3ODU2OTQ1ODV8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1708592956177-d29b4b4ce348?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHx0cmVlJTIwcGxhbnRhdGlvbiUyMHZvbHVudGVlcnxlbnwwfHx8fDE3ODU2OTQ1ODV8MA&ixlib=rb-4.1.0&q=85",
  ],
  i: [
    "https://images.unsplash.com/photo-1635351233587-d2e84e4f55e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxpbmRpYSUyMGZsb29kJTIwcmVzY3VlfGVufDB8fHx8MTc4NTY5NDU5Nnww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1659848372782-ef5b87dc5541?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxpbmRpYSUyMGZsb29kJTIwcmVzY3VlfGVufDB8fHx8MTc4NTY5NDU5Nnww&ixlib=rb-4.1.0&q=85",
  ],
};

const catLabels = {
  all: { en: "All", hi: "सभी" },
  a: { en: "Poor Aid", hi: "गरीबों की मदद" },
  b: { en: "Elderly", hi: "बुज़ुर्ग" },
  c: { en: "Education", hi: "शिक्षा" },
  d: { en: "Medical", hi: "चिकित्सा" },
  e: { en: "Women & Child", hi: "महिला व बाल" },
  f: { en: "Divyang", hi: "दिव्यांग" },
  g: { en: "Rural", hi: "ग्रामीण" },
  h: { en: "Environment", hi: "पर्यावरण" },
  i: { en: "Disaster", hi: "आपदा राहत" },
};

// Default gallery items — shown to visitors until admin uploads real photos.
const defaultGallery = Object.entries(areaImages).flatMap(([cat, urls]) =>
  urls.map((u, idx) => ({ image_url: u, title: catLabels[cat].en, category: cat, id: `${cat}-${idx}` }))
);

const Gallery = () => {
  const { t, lang } = useApp();
  const [items, setItems] = useState(defaultGallery);
  const [active, setActive] = useState("all");

  useEffect(() => {
    api.get("/gallery").then((r) => {
      // Admin-uploaded images shown first; defaults fill the rest so the page always looks alive.
      setItems([...r.data, ...defaultGallery]);
    }).catch(() => {});
  }, []);

  const filtered = active === "all" ? items : items.filter((i) => i.category === active);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="gallery-page">
      <div className="mb-12 animate-fade-up">
        <p className="text-xs uppercase tracking-[0.25em] text-[#C95B24] font-semibold mb-3">{t("gallery")}</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl text-[#1B4332] mb-4 leading-[1.05]">{t("galleryTitle")}</h1>
        <p className="text-lg text-[#4A4A4A]">{t("gallerySub")}</p>
      </div>

      <div className="flex flex-wrap gap-2 mb-10">
        {Object.entries(catLabels).map(([k, v]) => (
          <button
            key={k}
            onClick={() => setActive(k)}
            data-testid={`gallery-filter-${k}`}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${active === k ? "bg-[#1B4332] text-[#FDFBF7]" : "bg-[#F4EFE6] text-[#1B4332] hover:bg-[#DDD3C1]"}`}
          >
            {lang === "hi" ? v.hi : v.en}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
        {filtered.map((it, i) => (
          <div key={`${it.id}-${i}`} className="relative rounded-xl overflow-hidden aspect-square group animate-fade-up" data-testid={`gallery-item-${i}`}>
            <img src={it.image_url} alt={it.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B4332]/85 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
              <span className="text-[#FDFBF7] text-sm font-medium">{lang === "hi" && it.title_hi ? it.title_hi : it.title}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
